"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;
var _locales = require("../utils/locales");
const messages = exports.messages = {
  [_locales.locales.en]: {
    close: "Close panel"
  },
  [_locales.locales.es]: {
    close: "Cerrar panel"
  },
  [_locales.locales.fr]: {
    close: "Fermer le panneau"
  },
  [_locales.locales.pt]: {
    close: "Fechar painel"
  },
  [_locales.locales.zh]: {
    close: "關閉面板"
  },
  [_locales.locales.de]: {
    close: "Panel schließen"
  },
  [_locales.locales.it]: {
    close: "Chiudi pannello"
  },
  [_locales.locales.ja]: {
    close: "パネルを閉じる"
  },
  [_locales.locales.tl]: {
    close: "Isara ang panel"
  },
  [_locales.locales.hi]: {
    close: "पैनल बंद करें"
  },
  [_locales.locales.ko]: {
    close: "패널 닫기"
  }
};